import React, { createContext, FC, PropsWithChildren, useContext } from "react";
import {
  NextBestActionDefinitionAction,
  NextBestActionType,
} from "../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { NextBestActionCardStatus } from "../../../components/nextBestActionItem/NextBestActionItem";

interface NextBestActionContextValue {
  readonly actionStatuses: Record<string, NextBestActionCardStatus>;
  readonly onActionTriggered: (args: { action: NextBestActionDefinitionAction<NextBestActionType> }) => void;
  readonly onPressCta: () => void;
}

const NextBestActionContext = createContext<NextBestActionContextValue | undefined>(undefined);

interface NextBestActionProviderProps extends PropsWithChildren {
  readonly value: NextBestActionContextValue;
}

const NextBestActionProvider: FC<NextBestActionProviderProps> = ({ value, children }) => {
  return <NextBestActionContext.Provider value={value}>{children}</NextBestActionContext.Provider>;
};

const useNextBestAction = (): NextBestActionContextValue => {
  const context = useContext(NextBestActionContext);
  if (!context) {
    throw new Error("useNextBestAction must be used within a NextBestActionProvider");
  }
  return context;
};

export { NextBestActionProvider, useNextBestAction };
